import React, { Component } from 'react'

import classes from './SetupStructure.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
// import Button from '../../../../components/UI/Button/Button'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/SetupStructure/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Checkbox } from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class SetupStructure extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    addAno: false,
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      structure_name: {
        label: this.props.translate('structureName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('structureName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      structure_type_id: {
        label: this.props.translate('structureType'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('structureType'),
          options: []
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      target_score: {
        label: this.props.translate('targetScore'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          options: [],
          disabled: true
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      default_stage_id: {
        label: this.props.translate('stage'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('stage'),
          options: [],
          disabled: true
        },
        value: {},
        validation: {
          required: false
        },
        valid: true,
        touched: false,
        error: null
      },
      roles: {
        label: this.props.translate('permission'),
        elementType: 'newmultiSelect',
        elementConfig: {
          type: 'text',
          options: []
        },
        value: [],
        validation: false,
        valid: true,
        touched: false,
        error: null
      },
      seq_no: {
        label: this.props.translate('orderSeq'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('orderSeq')
        },
        value: '',
        validation: {
          required: true,
          isDecimal: true
        },
        valid: false,
        touched: false,
        error: null
      },
      is_get_zero: {
        label: this.props.translate('valueGetZero'),
        elementType: 'checkbox',
        disabled: true,
        value: false,
        validation: false,
        valid: true,
        touched: false,
        error: null
      },
      is_unlimited: {
        label: this.props.translate('unlimitedDeduction'),
        elementType: 'checkbox',
        disabled: true,
        value: false,
        validation: false,
        valid: true,
        touched: false,
        error: null
      },
      is_threshold: {
        label: this.props.translate('threshold'),
        elementType: 'checkbox',
        disabled: true,
        value: false,
        validation: false,
        valid: true,
        touched: false,
        error: null
      },
      is_competencyScore: {
        label: 'Competency Score',
        elementType: 'checkbox',
        disabled: true,
        value: false,
        validation: false,
        valid: true,
        touched: false,
        error: null
      },
      comment_score: {
        label: 'Score for Comment',
        elementType: 'checkboxGroup',
        elementConfig: {
          type: 'text',
          placeholder: 'Score for Comment',
          options: []
        },
        value: '',
        options: [],
        validation: {
          required: false
        },
        valid: true
        // touched: false,
        // error: null
      },
      is_self_delete_comment: {
        label: 'Self Delete Comment',
        elementType: 'checkbox',
        value: true,
        validation: false,
        valid: true
      },
      is_feedback: {
        label: 'Feedback',
        elementType: 'checkbox',
        value: false,
        validation: false,
        valid: true
      },
      is_active: {
        label: this.props.translate('active'),
        elementType: 'checkbox',
        value: true,
        validation: false,
        valid: true
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        }
      },
      structure_type_id: {
        label: this.props.translate('structureType'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('structureType'),
          options: []
        }
      },
      structure_id: {
        label: this.props.translate('structureName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('structureName'),
          options: []
        }
      },
      is_active: {
        label: this.props.translate('active'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('active'),
          options: []
        }
      }
    },
    updateProps: {
      companyOptions: this.props.companyOptions,
      structureTypeOptions: this.props.structureTypeOptions,
      targetScoreOptions: this.props.targetScoreOptions,
      stageOptions: this.props.stageOptions,
      permission: this.props.permission,
      filterCompany: this.props.filterCompany,
      filterStructure: this.props.filterStructure,
      filterStructureType: this.props.filterStructureType,
      filterActive: this.props.filterActive,
      selectedRecord: this.props.selectedRecord
    }
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('structure'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('structure'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.structure_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('structure'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.structure_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    { field: 'seq_no', title: this.props.translate('seqNo'), type: 'string' },
    { field: 'structure_name', title: this.props.translate('structureName'), type: 'string' },
    { field: 'company_name', title: this.props.translate('company'), type: 'string' },
    { field: 'target_score', title: this.props.translate('targetScore'), type: 'string' },
    { field: 'value_list_name', title: this.props.translate('structureType'), type: 'string' },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 100
    }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchStructure()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state

    const updateOptions = (stateId, propsId, attr, withCode) => {
      const inputGroups = state.inputGroups
      const targetStructureItem = inputGroups[stateId]
      let [attrId, attrCode, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetStructureItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder,
            null,
            null,
            withCode ? attrCode : null
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr
      let value = state.filterControls[stateId].value
      if (props[propsId].length === 0) {
        value = 'No Data'
      }
      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        'company_id',
        { code: 'company_code', name: 'company_name' },
        props.translate('select') + props.translate('company')
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.structureTypeOptions !== updateProps.structureTypeOptions) {
      updateOptions(
        'structure_type_id',
        'structureTypeOptions',
        [
          'value_list_id',
          'value_list_code',
          { code: 'value_list_code', name: 'value_list_name' },
          props.translate('select') + props.translate('structureType')
        ],
        true
      )
    }
    if (props.stageOptions !== updateProps.stageOptions) {
      updateOptions(
        'default_stage_id',
        'stageOptions',
        [
          'stage_id',
          'stage_id',
          { code: 'status_code', name: 'status_name' },
          props.translate('select') + props.translate('stage')
        ],
        true
      )

      if (props?.selectedRecord?.default_stage_id) {
        updatedState.inputGroups.default_stage_id.value =
          updatedState.inputGroups.default_stage_id.elementConfig.options.find(
            res => res.value === props?.selectedRecord?.default_stage_id
          ) || updatedState.inputGroups.default_stage_id.value
      }
      updatedState.inputGroups.default_stage_id.elementConfig.disabled = false
    }
    if (props.targetScoreOptions !== updateProps.targetScoreOptions) {
      updateOptions('target_score', 'targetScoreOptions', [
        'target_score',
        'target_score',
        'target_score',
        props.translate('select') + props.translate('targetScore')
      ])

      if (props?.selectedRecord?.target_score !== undefined) {
        updatedState.inputGroups.target_score.value =
          updatedState.inputGroups.target_score.elementConfig.options.find(
            res => +res.value === +props?.selectedRecord?.target_score
          ) || updatedState.inputGroups.target_score.value
      }
      updatedState.inputGroups.target_score.elementConfig.disabled = false
    }
    if (props.permission !== updateProps.permission) {
      updateOptions(
        'roles',
        'permission',
        [
          'role_id',
          'role_id',
          'role_name',
          props.translate('select') + props.translate('permission')
        ],
        true
      )
    }

    if (props.filterStructure !== updateProps.filterStructure) {
      updateFilter('structure_id', 'filterStructure', ['structure_id', 'structure_name'])
    }
    if (props.filterStructureType !== updateProps.filterStructureType) {
      updateFilter('structure_type_id', 'filterStructureType', [
        'structure_type_id',
        { code: 'structure_type_code', name: 'structure_type_name' }
      ])
    }
    if (props.filterActive !== updateProps.filterActive) {
      updateFilter('is_active', 'filterActive', ['active_id', 'active_name'])
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let { inputGroups } = state

      let newStructureData = Object.entries(inputGroups).reduce((structureGroups, structure) => {
        let [structureKey, structureAttrs] = structure
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (!structureAttrs.validation || !structureAttrs.validation.required) {
          valid = true
        }
        if (structureAttrs.elementType === 'checkbox') {
          value = false
          valid = true
        }

        if (props.selectedRecord) {
          value = props.selectedRecord[structureKey]

          if (structureAttrs.elementType === 'newselect') {
            value =
              inputGroups[structureKey].elementConfig?.options?.find(
                res => +res.value === +value
              ) || {}

            if (value === undefined && structureKey === 'target_score') {
              value = {
                value: props.selectedRecord[structureKey],
                key: props.selectedRecord[structureKey],
                label: `${props.selectedRecord[structureKey]}`
              }
            }
          }

          if (structureAttrs.elementType === 'newmultiSelect') {
            value = value.map(dat => {
              return inputGroups[structureKey].elementConfig.options.find(
                res => res.value === dat.role_id
              )
            })
          }

          if (structureAttrs.elementType === 'checkbox') {
            value = !!value
          }
          let { isValid, error } = checkValidity(
            value,
            structureAttrs.validation,
            structureAttrs.label
          )

          valid = isValid
          errorMessage = error
        }

        const newStructureAttrs = {
          ...structureAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }
        return updateObject(structureGroups, { [structureKey]: { ...newStructureAttrs } })
      }, {})

      const showCheckbox = name => {
        let [on_threshold, on_unlimited, on_get_zero, on_competencyScore, on_self_delete_comment] = name
        return {
          is_threshold: {
            ...newStructureData.is_threshold,
            value: on_threshold ? newStructureData.is_threshold.value : 0 ? false : true,
            disabled: !on_threshold
          },
          is_unlimited: {
            ...newStructureData.is_unlimited,
            value: on_unlimited ? newStructureData.is_unlimited.value : 0 ? false : true,
            disabled: !on_unlimited
          },
          is_get_zero: {
            ...newStructureData.is_get_zero,
            value: on_get_zero ? newStructureData.is_get_zero.value : 0 ? false : true,
            disabled: !on_get_zero
          },
          is_competencyScore: {
            ...newStructureData.is_competencyScore,
            value: on_competencyScore ? newStructureData.is_threshold.value : 0 ? false : true,
            // value: false,
            disabled: !on_competencyScore
          },
          is_self_delete_comment: {
            ...newStructureData.is_self_delete_comment,
            value: on_self_delete_comment ? newStructureData.is_self_delete_comment.value : 0 ? false : true,
            // value: false,
            disabled: !on_self_delete_comment
          }
        }
      }

      switch (newStructureData.structure_type_id.value.code) {
        case 'STT01':
          newStructureData = updateObject(
            newStructureData,
            showCheckbox([true, false, false, false,true])
          )
          break
        case 'STT02':
          newStructureData = updateObject(
            newStructureData,
            showCheckbox([false, false, false, true,true])
          )
          break
        case 'STT03':
          newStructureData = updateObject(
            newStructureData,
            showCheckbox([false, true, true, false,false])
          )
          break

        default:
          newStructureData = updateObject(
            newStructureData,
            showCheckbox([false, false, false, false,false])
          )
          break
      }
      updatedState = {
        ...updatedState,
        formValid: true,
        inputGroups: newStructureData,
        updateProps: { ...updateProps, selectedRecord: props.selectedRecord }
      }
    }
    return updatedState
  }

  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchStructure(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchStructure(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'target_score':
        case 'default_stage_id':
          newFormAttrs = {
            ...formAttrs,
            elementConfig: {
              disabled: true
            },
            valid: false,
            value: ''
          }
          break
        case 'is_get_zero':
          newFormAttrs = {
            ...formAttrs,
            valid: false,
            value: false
          }
          break
        case 'is_unlimited':
          newFormAttrs = {
            ...formAttrs,
            valid: false,
            value: false
          }
          break
        case 'is_threshold':
          newFormAttrs = {
            ...formAttrs,
            valid: false,
            value: false
          }
          break
        case 'is_competencyScore':
          newFormAttrs = {
            ...formAttrs,
            valid: false,
            value: false
          }
          break
        case 'is_active':
          newFormAttrs = {
            ...formAttrs,
            valid: false,
            value: true
          }
          break
        case 'roles':
          newFormAttrs = {
            ...formAttrs,
            valid: false,
            value: []
          }
          break
        default:
          newFormAttrs = {
            ...formAttrs,
            valid: false,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})

    this.setState({
      inputGroups: newFormData
    })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchStructureById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }
  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }
  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }
  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        formValid: false,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        formValid: false,
        modalOpen: false
      })
    }
  }

  structureSubmitHandler = type => {
    let structureData = Object.entries(this.state.inputGroups).reduce(
      (structureData, structureEntry) => {
        let [structureKey, structureAttrs] = structureEntry
        let value = ''
        if (structureAttrs.elementType === 'newselect') {
          value = structureAttrs.value?.value
        } else if (structureAttrs.elementType === 'newmultiSelect') {
          value = structureAttrs.value.map(res => {
            return { role_id: res.value }
          })
        } else {
          value = structureAttrs.value
        }
        if (structureKey === 'is_competencyScore') {
          structureKey = 'is_threshold'
          // value = structureAttrs.value
        }
        return { ...structureData, [structureKey]: value }
      },
      {}
    )
    if (this.state.action === 'add') {
      this.props.createStructure({ ...structureData }, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateStructure(
        this.state.actionRecordId,
        { ...structureData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (structureKey, event) => {
    const inputGroup = this.state.inputGroups

    const structureItem = inputGroup[structureKey]

    let inputValue = ''

    switch (structureItem.elementType) {
      case 'textEditor':
        inputValue = event.target.getContent()
        break
      case 'newselect':
        inputValue = event
        break
      case 'datePicker':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !structureItem.value
        break
      case 'newmultiSelect':
        inputValue = event
        break

      default:
        inputValue = event.target.value
        break
    }

    const { isValid, error } = checkValidity(
      inputValue,
      structureItem.validation,
      structureItem.label
    )

    let updatedStructureItem = {
      ...structureItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [structureKey]: updatedStructureItem })

    const filterOptions = {
      company_id: updateGroup.company_id.value?.value,
      structure_type_id: updateGroup.structure_type_id.value?.value
    }

    if (structureKey === 'company_id' || structureKey === 'structure_type_id') {
      if (filterOptions.company_id && filterOptions.structure_type_id) {
        this.props.fetchStageOptions(filterOptions)
      }
    }

    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })
    let newStructure = inputGroup
    if (structureKey === 'structure_type_id' && inputValue) {
      let targetSent = inputValue.code
      this.props.fetchTargetScoreOptions(targetSent)
      newStructure = updateObject(newStructure, { [structureKey]: updatedStructureItem })
      const showCheckbox = name => {
        let [on_threshold, on_unlimited, on_get_zero, on_competencyScore, comment_score,on_self_delete_comment] = name
        return {
          is_threshold: {
            ...inputGroup.is_threshold,
            value: on_threshold ? inputGroup.is_threshold.value : false,
            disabled: !on_threshold
          },
          is_unlimited: {
            ...inputGroup.is_unlimited,
            value: on_unlimited ? inputGroup.is_unlimited.value : false,
            disabled: !on_unlimited
          },
          is_get_zero: {
            ...inputGroup.is_get_zero,
            value: on_get_zero ? inputGroup.is_get_zero.value : false,
            disabled: !on_get_zero
          },
          is_competencyScore: {
            ...inputGroup.is_competencyScore,
            value: on_competencyScore ? inputGroup.is_competencyScore.value : false,
            disabled: !on_competencyScore
          },
          comment_score: {
            ...inputGroup.comment_score,
            value: comment_score ? inputGroup.comment_score.value : ''
          },
          is_self_delete_comment: {
            ...inputGroup.is_self_delete_comment,
            value: on_self_delete_comment ? inputGroup.is_self_delete_comment.value : false,
            disabled: !on_self_delete_comment
          }
        }
      }
      console.log(inputValue.code)
      switch (inputValue.code) {
        case 'STT01':
          newStructure = updateObject(newStructure, {
            [structureKey]: updatedStructureItem,
            ...showCheckbox([true, false, false, false, false,true])
          })
          break
        case 'STT02':
          newStructure = updateObject(newStructure, {
            [structureKey]: updatedStructureItem,
            ...showCheckbox([false, false, false, true, false,true])
          })
          break
        case 'STT03':
          newStructure = updateObject(newStructure, {
            [structureKey]: updatedStructureItem,
            ...showCheckbox([false, true, true, false, false,false])
          })
          break

        default:
          newStructure = updateObject(newStructure, {
            [structureKey]: updatedStructureItem,
            ...showCheckbox([false, false, false, false, false])
          })
          break
      }
    } else {
      newStructure = updateObject(newStructure, { [structureKey]: updatedStructureItem })
    }
    let valid = true
    console.log('newStructure',newStructure)
    Object.entries(newStructure).reduce((structureData, structureEntry) => {
      let [, structureAttrs] = structureEntry
      let { isValid } = checkValidity(
        structureAttrs.value,
        structureAttrs.validation,
        structureAttrs.label
      )
      valid = valid && isValid
      return { ...structureData }
    }, {})
    this.setState({
      inputGroups: newStructure,
      formValid: valid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = updateObject(filterControls, {
        [datakey]: { ...filterControls[datakey], value: '' }
      }))
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId
    this.props.deleteStructure(recordId, getPageStatus(this.props.pagination, true))
    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]

    this.setState(
      {
        filterControls: updateObject(this.state.filterControls, {
          [itemKey]: {
            ...filterItem,
            value: filterValue
          }
        }),
        filter: { ...this.state.filter, [itemKey]: filterValue?.value }
      },
      () => {
        this.props.fetchFilter(this.state.filter)
      }
    )
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    this.props.fetchStructure(this.state.filter)
    this.closeFilterModal()
  }

  scoreChanged = key => {
    let newInputgroup = this.state.inputGroups
    let newOption = { ...this.state.inputGroups.comment_score }
    newOption.options = newOption.options.map(item => {
      if (item.key === key) {
        return {
          ...item,
          value: !item.value
        }
      }
      return item
    })
    let score = []
    if (newOption.value?.length > 0) {
      score = newOption.value.split(',')
    }
    let check = score.find(v => +v === +key)
    if (!check) {
      score.push(key)
    } else {
      score = score.filter(v => {
        return +v !== +key && v !== ''
      })
    }
    newOption.value = score.toString()
    newInputgroup = updateObject(newInputgroup, { ...newInputgroup, comment_score: newOption })
    this.setState({
      inputGroups: newInputgroup
    })
  }

  render() {
    let form = <Spinner />
    if (this.state.action === 'edit') {
      if (this.props.selectedRecord && !this.props.loading) {
        form = (
          <Form
            form={this.state.inputGroups}
            inputChanged={this.inputChangeHandler}
            scoreChanged={key => this.scoreChanged(key)}
          />
        )
      }
    } else if (!this.props.loading) {
      form = (
        <Form
          form={this.state.inputGroups}
          inputChanged={this.inputChangeHandler}
          scoreChanged={key => this.scoreChanged(key)}
        />
      )
    }

    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.structureSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>
    // )
    const footer = (
      <Footer
        save={() => this.structureSubmitHandler('save')}
        another={() => this.structureSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.inputGroups)}
      />
    )
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('structure')}
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>{form}</div>
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('structure')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.structure.pagination,
    data: state.structure.records,
    permission: state.structure.permissionRecords,
    loading: state.structure.loading,
    filterLoading: state.structure.filterLoading,
    success: state.structure.success,
    selectedRecord: state.structure.selectedRecord,
    companyOptions: state.structure.company,
    stageOptions: state.structure.stage,
    structureTypeOptions: state.structure.structureType,
    targetScoreOptions: state.structure.targetScore,
    filterCompany: state.structure.filterCompany,
    filterStructure: state.structure.filterStructure,
    filterStructureType: state.structure.filterStructureType,
    filterActive: state.structure.filterActive,
    loadingQueue: state.structure.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchStructure: filterOptions => dispatch(actions.fetchStructure(filterOptions)),
    fetchStructureById: recordId => dispatch(actions.fetchStructureById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedStructureRecord()),
    createStructure: (recordData, page) => dispatch(actions.createStructure(recordData, page)),
    updateStructure: (recordId, recordData, page) =>
      dispatch(actions.updateStructure(recordId, recordData, page)),
    deleteStructure: (recordId, page) => dispatch(actions.deleteStructure(recordId, page)),
    fetchTargetScoreOptions: recordId => dispatch(actions.fetchTargetScoreOptions(recordId)),
    fetchStageOptions: filterOptions => dispatch(actions.fetchStageOptions(filterOptions)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchStructureTypeOptions())
      dispatch(actions.fetchRoleOptions())
    },
    fetchFilter: filter => {
      dispatch(actions.fetchStructureFilterStructure(filter))
      dispatch(actions.fetchStructureFilterStructureType(filter))
      dispatch(actions.fetchStructureFilterActive(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupStructure))
